namespace OSF {
  export var RibbonControlIdMap: any = {};
  export var RibbonGroupIdMap: any = {};
  export var RibbonGroupIdMapMLR: any = {};
  export var RibbonGroupIdMapCommonMLR: any = {};
  export var RibbonGroupIdMapCommonSLR: any = {};
}

OSF.RibbonControlIdMap = {};
OSF.RibbonGroupIdMap = {};
OSF.RibbonGroupIdMapMLR = {};
OSF.RibbonGroupIdMapCommonMLR = {};
OSF.RibbonGroupIdMapCommonSLR = {};
